//
// Format a decimal value to a string to match .NET formatting.
//
export default function FormatDecimal(value: number, format: string): string {
  const fractionDigits = parseInt(format.slice(1));
  switch (format[0]) {
    case "F":
      return value.toFixed(fractionDigits);
    case "N":
      return value.toLocaleString(undefined, {
        maximumFractionDigits: fractionDigits,
        minimumFractionDigits: fractionDigits,
      });
    case "C":
      return value.toLocaleString(undefined, {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: fractionDigits,
        minimumFractionDigits: fractionDigits,
      });
    case "P":
      return value.toLocaleString(undefined, {
        style: "percent",
        maximumFractionDigits: fractionDigits,
        minimumFractionDigits: fractionDigits,
      });
    default:
      throw new Error("Invalid format: " + format);
  }
}
